import React from 'react'
import { Popover, Box } from '@mui/material'

const PopoverComponent = ({ children, trigger }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <Box>
            <Box onClick={handleClick} sx={{ cursor: 'pointer' }}>
                {trigger}
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{
                    sx: { width: 'auto', maxWidth: 600, p: 2, borderRadius: 1.5, boxShadow: 3 }
                }}
            >
                {children}
            </Popover>
        </Box>
    )
}

export default PopoverComponent
